import React, { useState } from 'react';
import  '../../styles/Sidebar.css';
import  '../../styles/Dashboard.css';
import  '../../styles/Evaluations.css';
import EvaluationForm from '../../components/Evaluations';

function Evaluations() {
    return (
        <div className="Campaign-layout"> 
            <EvaluationForm />
        </div> 
    );
}

export default Evaluations;
